import general from './general.reducer';
import demande from './demande.reducer';
import multiplex from './multiplex.reducer';
import typeDefaut from './type-defaut.reducer';
import typePerturbation from './type-perturbation.reducer';

import {
  combineReducers
} from 'redux';

const reducers = combineReducers({
  demande,
  multiplex,
  typeDefaut,
  typePerturbation,
  general
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/combine-reducers.js